export const table_titles = [
	{ name: "#", size: 5, order: "" },
	{ name: "Nombre", size: 20, order: "name" },
	{ name: "Categoría", size: 10, order: "category_name" },
	{ name: "Campo", size: 10, order: "" },
	{ name: "Grupo Campo", size: 10, order: "" },
	{ name: "Cliente", size: 10, order: "customer_name", only_admin: true },
	{ name: "Acción", size: 10, order: "" },
];

export const customStyles = {
	menuPortal: (base) => ({
		...base,
		zIndex: 9999999,
	}),
	menu: (provided) => ({ ...provided, zIndex: 9999999 }),
};

export const filters = {
	filter_customer: "",
	filter_estate: "",
	filter_category: "",
};
